export const formatWorkshiftLabel = (workshift) => {
  const name = workshift?.name || '';
  const from = workshift?.hour_from?.slice(0, 5);
  const to = workshift?.hour_to?.slice(0, 5);
  return from && to ? `${name} (${from} a ${to})` : name;
};
